import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';
import InstrumentAudit from '../pages/InstrumentAudit';
import Kpis from '../pages/Kpis';
import LoginPage from '../pages/LoginPage';
import { useAuth } from '../context/AuthContext';

export default function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          user ? <DashboardLayout /> : <Navigate to="/login" replace />
        }
      >
        <Route index element={<Navigate to="/instrument-audit" />} />
        <Route path="instrument-audit" element={<InstrumentAudit />} />
        <Route path="kpis" element={<Kpis />} />
      </Route>
      <Route
        path="*"
        element={<Navigate to={user ? '/instrument-audit' : '/login'} replace />}
      />
    </Routes>
  );
}